import React from "react";
import { Outlet, NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { RiFingerprintLine } from "react-icons/ri";
import { RiArrowUpSLine } from "react-icons/ri";
import { RiArrowDownSLine } from "react-icons/ri";
import "./styles.css";

const PageWrapper = () => {
	const isLoggedIn = useSelector((state) => state.registeredUser.isLoggedIn);
	const user = useSelector((state) => state.registeredUser.user);

	return (
		<>
			<div id="header1">
				<div className="tech">Rapid Fire</div>
			</div>

			<div id="header2">
				<div className="blurb">
					Welcome to Night City, 2077. Race against your opponents in this fast
					answer quiz.{" "}
				</div>
				<div className="icon">
					<a href="#wrapper">
						<i className="ri-fingerprint-line">
							<RiFingerprintLine />
						</i>
					</a>
				</div>
				<div className="links">
					<NavLink to="/">Home</NavLink>
					<NavLink to="/scores">Leaderboard</NavLink>
					<NavLink to="/lobby">Rooms</NavLink>
					{user ? (
						<NavLink to="/logout">Log Out</NavLink>
					) : (
						<NavLink to="/register">Log In</NavLink>
					)}
					{isLoggedIn ? <NavLink to="/profile">Profile</NavLink> : <></>}
				</div>
			</div>

      <div id="wrapper">
        <div id="userBar">
          <div className="left"></div>
          <div className="middle">
            <a className="name" id="none" href="/">
              A
            </a>
            <a className="name" id="none" href="/">
              p
            </a>
            <a className="name" id="none" href="/">
              p
            </a>
            <a
              className="name"
              id="rickRoll"
              href="https://shattereddisk.github.io/rickroll/rickroll.mp4"
              target={"_blank"}
            >
              R
            </a>
            <a className="name" id="none" href="/">
              a
            </a>
            <a className="name" id="none" href="/">
              i
            </a>
            <a className="name" id="none" href="/">
              s
            </a>
            <a className="name" id="none" href="/">
              e
            </a>
            &nbsp; &nbsp; &nbsp;
            <a className="name" id="none" href="/">
              y
            </a>
            <a className="name" id="none" href="/">
              o
            </a>
            <a className="name" id="none" href="/">
              u
            </a>
            <a
              className="name"
              id="rickRoll"
              href="https://shattereddisk.github.io/rickroll/rickroll.mp4"
              target={"_blank"}
            >
              r
            </a>
            &nbsp; &nbsp; &nbsp;
            <a className="name" id="none" href="/">
              m
            </a>
            <a className="name" id="none" href="/">
              i
            </a>
            <a className="name" id="none" href="/">
              n
            </a>
            <a className="name" id="none" href="/">
              d
            </a>
          </div>
          <div className="right"></div>
        </div>

				<div className="triLeft"></div>
				<div className="triRight"></div>

				<div id="navigation">
					<div className="navigation">
						<div className="nav">
							<NavLink to="/">Test</NavLink>
							<div className="sep"></div>
							<NavLink to="/">Your</NavLink>
							<div className="sep"></div>
							<NavLink to="/">Knowledge</NavLink>
						</div>
					</div>
				</div>

				<div id="innerwrapper">
					<Outlet />
				</div>

				<div id="jump">
					<a href="javascript:scroll(0,0);" title="scroll to top">
						<i className="ri-arrow-up-s-line">
							{" "}
							<RiArrowUpSLine />{" "}
						</i>
					</a>
					<div className="sep"></div>
					<a href="#bottom" title="scroll to bottom">
						<i className="ri-arrow-down-s-line">
							{" "}
							<RiArrowDownSLine />{" "}
						</i>
					</a>
				</div>
			</div>
			<div id="bottom"></div>
		</>
	);
};

export default PageWrapper;
